export default __webpack_public_path__ + "static/media/NeueMachina-Medium.952596a4.woff";